import apiClient from '../apiClient';
import { GET_RESTAURANT_BY_CITY_DATE_PAX_URL } from '../apiUrl';

const getRestaurantByCityDateAndPaxApi = (city, date, pax) => {
  return apiClient.get(GET_RESTAURANT_BY_CITY_DATE_PAX_URL(city, date, pax));
};

export default getRestaurantByCityDateAndPaxApi;
